import { MANDATORY, VANILLA } from '../../constants/control-type';
import { EntityConfigFieldTypeUri } from '../../enums/field-type-uris.enum';

export enum FieldPropertyValues {
  URI = 'uri',
  LABEL = 'label',
  VALUE = 'value',
  NAME = 'name',
  DESCRIPTION = 'description',
  COLOR = 'color',
  OPTIONS = 'options',
  FIELD_URI = 'fieldUri',
  WEIGHT = 'weight'
}

export interface FieldPropertyValueData {
  uri?: string;
  label?: string;
  value?: string | number;
  name?: string;
  description?: string;
  color?: string;
  options?: Array<FieldPropertyValueData>;
  weight?: number;
  fieldUri?: string;
  fieldVersion?: string;
}
export interface FieldPropertyValue {
  fieldTypePropertyUri: string;
  value: Array<FieldPropertyValueData> | string;
  fieldUri?: string;
}

export interface MappedEntityConfigField {
  [fieldUri: string]: EntityConfigField;
}

export abstract class EntityConfigField {
  public uri: string;
  public name: string;
  public tenantUri: string;
  public fieldTypeUri: EntityConfigFieldTypeUri;
  public version?: number;
  public createdOn: number;
  public createdByUri: string;
  public updatedOn?: number;
  public updatedByUri?: string;
  public propertyValues: Array<FieldPropertyValue>;
  public mandatory?: boolean;
  public spaceUri?: string;
  // To identify the itonics field
  public default?: boolean;

  public static isMandatory(field: EntityConfigField) {
    // In EC 3.1 to identify the Mandatory field we have dedicated property mandatory and
    // field.tenantUri === MANDATORY won't be valid
    return field.tenantUri === MANDATORY || field?.mandatory;
  }

  public static isVanilla(field: EntityConfigField) {
    return field.tenantUri === VANILLA || field.default;
  }
}

export interface EntityConfigFieldInput {
  uri?: string;
  name: string;
  tenantUri: string;
  fieldTypeUri: string;
  version?: number;
  propertyValues?: Array<FieldPropertyValue>;
}

export interface EntityConfigFieldInputV2 {
  uri?: string;
  name: string;
  spaceUri: string;
  fieldTypeUri: string;
  version?: number;
  propertyValues?: Array<FieldPropertyValue>;
}

export interface AggregatedRatingFormula {
  uri: string;
  fieldUri: string;
  fieldVersion: string;
  weight: string;
}
